import { Box, Grid, Image } from "@mantine/core";
import { OrderInfoViewProps } from "./_types";
import { InfoItemPlain } from "components/ui/InfoItem";
import { checkItemValidity } from "./_utils";
import ResponsiveView from "components/ui/ResponsiveView";

const GetDeliveryLocation: React.FC<OrderInfoViewProps> = ({ order, invalidFields }) => {
    return (
        <Box>

            <Grid grow gutter="xs">

                <Grid.Col span={12}>
                    <InfoItemPlain label="Location" value={order.delivery_geo} validation={checkItemValidity('delivery_geo', invalidFields)} />
                </Grid.Col>

                {order.delivery_geo?(
                    <Grid.Col span={12}>
                        <ResponsiveView
                            renderDesktop={
                                <Image
                                    radius="md"
                                    src={`https://maps.googleapis.com/maps/api/staticmap?center=${order.delivery_geo}&zoom=11&size=900x200&key=AIzaSyCpm1d5SwHD8Zb8fLx8c0EujWR0ylx3FFU&markers=size:mid%7Ccolor:0xff0000%7Clabel:%7C${order.delivery_geo}`}
                                    alt={order.delivery_geo||''} />
                            }
                            renderMobile={
                                <Image
                                    radius="md"
                                    src={`https://maps.googleapis.com/maps/api/staticmap?center=${order.delivery_geo}&zoom=11&size=400x300&key=AIzaSyCpm1d5SwHD8Zb8fLx8c0EujWR0ylx3FFU&markers=size:mid%7Ccolor:0xff0000%7Clabel:%7C${order.delivery_geo}`}
                                    alt={order.delivery_geo||''} />
                            }
                        />
                    </Grid.Col>
                ):null}

            </Grid>

        </Box>
    )
}

export default GetDeliveryLocation;